export default __webpack_public_path__ + "static/media/buy_geos_banner.f109743e.png";